import React from 'react';

import { Badge, Flex, Typography } from 'antd';

interface IProps {
  children: React.ReactNode | string;
}

const StepGuide = ({ children }: IProps) => {
  return (
    <Flex align='center' gap='small' className='w-full px-4.5 py-2'>
      <Badge status='processing' />
      <Typography.Text type='secondary'>{children}</Typography.Text>
    </Flex>
  );
};

export default React.memo(StepGuide);
